'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";


export default ['$scope', '$uibModalInstance', 'municipality', 'MunicipalityService', 'StatusService',
    function ($scope, $modalInstance, municipality, MunicipalityService, StatusService) {

        $scope.ok = ok;
        $scope.cancel = cancel;
        $scope.checkUniqueName = checkUniqueName;

        init();

        // region Function

        function init() {
            $scope.uniqueName = true;
            $scope.municipality = angular.copy(municipality);

            if (municipality == null || angular.equals({}, municipality) || municipality.id == null) {
                $scope.title = "Создание нового муниципального образования";
            } else {
                $scope.title = "Редактирование муниципального образования \"" + $scope.municipality.name + "\"";
            }

            StatusService.api.default(null, (data) => {
                if (!$scope.municipality.status) {
                    $scope.municipality.status = data._embedded;
                }
            });
        }

        function ok() {
            $modalInstance.close($scope.municipality);
        }

        function cancel() {
            $modalInstance.dismiss();
        }

        function checkUniqueName(name) {
            if (name != null && name.trim() != "") {
                MunicipalityService.api.isUniqueName({name: name}, {id: $scope.municipality.id}, (data) => {
                    $scope.uniqueName = data._embedded;
                });
            } else {
                $scope.uniqueLogin = true;
            }
        }

        // endregion

    }];